import Welcome from "../components/Main/Welcome";

const MainPage = () => {
    return <Welcome/>

}
export default MainPage;